// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1s5h3","info":"UpdateTermsInfo_info__2C-Zt"};